import { render } from "./ScrollingDocument.vue?vue&type=template&id=43fe5352"
import script from "./ScrollingDocument.vue?vue&type=script&lang=js"
export * from "./ScrollingDocument.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__